<template>
    <div class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">
          {{ route.params.id ? 'Editar Produto' : 'Novo Produto' }}
        </h4>
        <button class="btn btn-secondary btn-sm me-3" @click="voltar">Voltar</button>
      </div>
  
      <BaseForm
        :isFormValid="isFormValid"
        :isSubmitting="isSubmitting"
        @submit="salvarProduto"
        @cancel="voltar"
      >
        <FormSection title="Informações do Produto">
            <div class="row">
                <div class="col-md-2">
                <InputField
                    v-model="produto.codigo"
                    label="Código <span class='required'>*</span>"
                    id="codigo"
                    placeholder="Digite o código"
                    required
                    :class="{ 'error-input': errors.codigo }"
                />
                </div>
                <div class="col-md-8">
                <InputField
                    v-model="produto.nome"
                    label="Nome <span class='required'>*</span>"
                    id="nome"
                    placeholder="Digite o nome"
                    required
                    :class="{ 'error-input': errors.nome }"
                />
                </div>
  
                <div class="col-md-2">
                <InputField
                    v-model.number="produto.estoque"
                    label="Estoque <span class='required'>*</span>"
                    id="estoque"
                    type="number"
                    min="0"
                    required
                    :class="{ 'error-input': errors.estoque }"
                />
                </div>
                <div class="col-md-2">
                <InputField
                    v-model.number="produto.estoque_minimo"
                    label="Estoque Mínimo"
                    id="estoque_minimo"
                    type="number"
                    min="0"
                />
                </div>
                <div class="col-md-5">
                <SelectField
                    v-model="produto.categoria_id"
                    :options="categoriasOptions"
                    label="Categoria <span class='required'>*</span>"
                    id="categoria_id"
                    required
                    :class="{ 'error-input': errors.categoria_id }"
                />
                </div>
            </div>
        </FormSection>
  
        <FormSection title="Preços">
          <div class="row">
            <div class="col-md-4">
              <InputField
                v-model="precoCustoDisplay"
                label="Preço de Custo"
                id="preco_custo"
                placeholder="0,00"
                @focus="onFocusPrecoCusto"
                @blur="onBlurPrecoCusto"
                :class="{ 'error-input': errors.preco_custo }"
              />
            </div>
            <div class="col-md-4">
              <InputField
                v-model="precoVendaDisplay"
                label="Preço de Venda <span class='required'>*</span>"
                id="preco_venda"
                placeholder="0,00"
                required
                @focus="onFocusPrecoVenda"
                @blur="onBlurPrecoVenda"
                :class="{ 'error-input': errors.preco_venda }"
              />
            </div>
            <div class="col-md-3">
                <SelectField
                    v-model="produto.unidade"
                    :options="unidadesOptions"
                    label="Unidade <span class='required'>*</span>"
                    id="unidade"
                    required
                    :class="{ 'error-input': errors.unidade }"
                />
            </div>
          </div>
        </FormSection>
  
        <FormSection title="Status">
          <div class="form-group mt-3">
            <label for="ativo">Status <span class="required">*</span></label>
            <div class="form-switch">
              <input
                type="checkbox"
                id="ativo"
                v-model="produto.ativo"
                class="form-check-input"
              />
              <label for="ativo" class="form-check-label">
                {{ produto.ativo ? 'Ativo' : 'Inativo' }}
              </label>
            </div>
          </div>
        </FormSection>
      </BaseForm>
    </div>
  </template>
  
  <script>
  import { reactive, ref, computed, onMounted, watch } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import InputField from '@/components/Layout/InputField.vue';
  import SelectField from '@/components/Layout/SelectField.vue';
  import FormSection from '@/components/Layout/FormSection.vue';
  import BaseForm from '@/components/Layout/BaseForm.vue';
  import axios from '@/services/axios';
  import globalUtils from '@/utils/globalUtils.js';
  
  export default {
    components: { InputField, SelectField, FormSection, BaseForm },
    setup() {
      const route = useRoute();
      const router = useRouter();
  
      const produto = reactive({
        id: null,
        codigo: '',
        nome: '',
        estoque: 0,
        estoque_minimo: 0,
        preco_custo: null,
        preco_venda: null,
        unidade: null,
        categoria_id: null,
        ativo: true
      });
  
      const errors = reactive({});
      const isSubmitting = ref(false);
      const categoriasOptions = ref([]);

      const unidadesOptions = ref([
      { value: null,        text: 'Selecione', disabled: true },
      { value: 'Caixa',   text: 'Caixa'   },
      { value: 'Outra',   text: 'Outra'   },
      { value: 'Pacote',  text: 'Pacote'  },
      { value: 'Quilo',   text: 'Quilo'   },
      { value: 'Resma',   text: 'Resma'   },
      { value: 'Saco',    text: 'Saco'    },
      { value: 'Unidade', text: 'Unidade' }
    ]);

 
      const precoCustoDisplay = ref('');
      const precoVendaDisplay = ref('');
  
      // Sync display back to model immediately
      watch(precoCustoDisplay, val => {
        const num = parseFloat(val.replace(/[^\d,]/g, '').replace(',', '.'));
        produto.preco_custo = isNaN(num) ? null : num;
      });
      watch(precoVendaDisplay, val => {
        const num = parseFloat(val.replace(/[^\d,]/g, '').replace(',', '.'));
        produto.preco_venda = isNaN(num) ? null : num;
      });
  
      // Focus: strip formatting
      const onFocusPrecoCusto = () => {
        if (typeof produto.preco_custo === 'number') {
          precoCustoDisplay.value = produto.preco_custo
            .toFixed(2)
            .replace('.', ',');
        }
      };
      const onFocusPrecoVenda = () => {
        if (typeof produto.preco_venda === 'number') {
          precoVendaDisplay.value = produto.preco_venda
            .toFixed(2)
            .replace('.', ',');
        }
      };
  
      // Blur: apply currency format
      const onBlurPrecoCusto = () => {
        precoCustoDisplay.value =
          typeof produto.preco_custo === 'number'
            ? globalUtils.formatarValor(produto.preco_custo)
            : '';
      };
      const onBlurPrecoVenda = () => {
        precoVendaDisplay.value =
          typeof produto.preco_venda === 'number'
            ? globalUtils.formatarValor(produto.preco_venda)
            : '';
      };
  
      const validateForm = () => {
        errors.codigo = produto.codigo.trim() ? '' : 'Código é obrigatório.';
        errors.nome = produto.nome.trim() ? '' : 'Nome é obrigatório.';
        errors.estoque =
          Number.isInteger(produto.estoque) && produto.estoque >= 0
            ? ''
            : 'Estoque não pode ser negativo.';
        errors.preco_custo =
          produto.preco_custo === null ||
          (typeof produto.preco_custo === 'number' && produto.preco_custo >= 0)
            ? ''
            : 'Preço de custo inválido.';
        errors.preco_venda =
          typeof produto.preco_venda === 'number' && produto.preco_venda >= 0
            ? ''
            : 'Preço de venda inválido.';
        errors.categoria_id =
          produto.categoria_id != null ? '' : 'Selecione uma categoria.';
        errors.unidade =
          produto.unidade ? '' : 'Selecione a unidade.';

      };
  
      const isFormValid = computed(() => {
        const semErros = Object.values(errors).every(e => !e);
        const codigoOk = produto.codigo.trim().length > 0;
        const nomeOk = produto.nome.trim().length > 0;
        const vendaOk = typeof produto.preco_venda === 'number' && !isNaN(produto.preco_venda);
        const categoriaOk = produto.categoria_id != null;
        const unidadeOk   = Boolean(produto.unidade);
        return semErros && codigoOk && nomeOk && vendaOk && categoriaOk && unidadeOk;
      });
  
      const salvarProduto = async () => {
        validateForm();
        if (!isFormValid.value || isSubmitting.value) return;
        isSubmitting.value = true;
        try {
          const method = produto.id ? 'put' : 'post';
          const url = produto.id
            ? `/cadastros/produtos/${produto.id}`
            : '/cadastros/produtos';
          await axios[method](url, { ...produto });
          router.push('/cadastros/produtos');
        } catch (err) {
          console.error('Erro ao salvar produto:', err);
        } finally {
          isSubmitting.value = false;
        }
      };
  
      const voltar = () => router.push('/cadastros/produtos');
  
      onMounted(async () => {
        // load categories
        try {
          const res = await axios.get('/cadastros/categorias-de-produtos', {
            params: { page: 1, limit: 1000, ativo: true }
          });
          // categoriasOptions
          categoriasOptions.value = [
            { value: null, text: 'Selecione', disabled: true, selected: true },
            ...res.data.data.map(c => ({ value: c.id, text: c.nome }))
          ];
        } catch (err) {
          console.error('Erro ao carregar categorias:', err);
        }
  
        // load product if editing
        const id = route.params.id;
        if (id) {
          try {
            const { data } = await axios.get(`/cadastros/produtos/${id}`);
            Object.assign(produto, {
              id: data.id,
              codigo: data.codigo,
              nome: data.nome,
              estoque: data.estoque,
              estoque_minimo: data.estoque_minimo,
              unidade: data.unidade,
              categoria_id: data.categoria_id,
              ativo: data.ativo,
              preco_custo:
                typeof data.preco_custo === 'string'
                  ? parseFloat(data.preco_custo.replace(',', '.'))
                  : data.preco_custo,
              preco_venda:
                typeof data.preco_venda === 'string'
                  ? parseFloat(data.preco_venda.replace(',', '.'))
                  : data.preco_venda
            });
            // initialize displays
            precoCustoDisplay.value =
              typeof produto.preco_custo === 'number'
                ? globalUtils.formatarValor(produto.preco_custo)
                : '';
            precoVendaDisplay.value =
              typeof produto.preco_venda === 'number'
                ? globalUtils.formatarValor(produto.preco_venda)
                : '';
          } catch (err) {
            console.error('Erro ao carregar produto para edição:', err);
          }
        }
      });
  
      return {
        route,
        produto,
        errors,
        categoriasOptions,
        unidadesOptions,
        precoCustoDisplay,
        precoVendaDisplay,
        onFocusPrecoCusto,
        onBlurPrecoCusto,
        onFocusPrecoVenda,
        onBlurPrecoVenda,
        isFormValid,
        isSubmitting,
        salvarProduto,
        voltar
      };
    }
  };
  </script>
  
   
       
  <style scoped>
  .card { max-width: 90%; margin: 0 auto; }
  .error-input { border-color: #dc3545; }
  .form-switch { display: flex; align-items: center; gap: 10px; }
  .row { margin-bottom: 1rem; }

/* seleciona qualquer select que esteja inválido (placeholder) */
select:invalid {
  color: #6c757d; /* cinza típico de placeholder */
}

/* e, quando válido (valor diferente de ""), volta ao texto padrão */
select:valid {
  color: #212529; /* cor padrão de texto */
}


  </style>
  